// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ea77d42b","239":"a3344da1","450":"e957a88b","455":"fad81a59","607":"5fb9439f","762":"9b693f00"}[chunkId] + ".chunk.js";
};